module.exports = __webpack_public_path__ + "images/58d0e57732a6444a8f9825177e1fbe54.jpg";